import { IArtist } from "@interfaces/artist";
import IPartner from "@interfaces/partner";
import TPartnerDto from "types/Partner/partnerDto";

export const apiPartnerToDto = ({
  name,
  description,
  imageUrl,
  heroImageUrl,
  order,
  artists,
}: IPartner): TPartnerDto => ({
  name,
  description,
  imageUrl,
  heroImageUrl,
  order,
  artists:
    artists &&
    sortArtistArray(artists).map((artist) => ({
      displayName: artist.displayName.toUpperCase(),
      walletAddress: artist.walletAddress,
    })),
});

const sortArtistArray = (array: IArtist[]): IArtist[] => {
  return array.sort((a, b) => {
    const nameA = a.displayName.toLowerCase();
    const nameB = b.displayName.toLowerCase();

    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  });
};
